import { Component, OnInit } from '@angular/core';
import { EbayService } from 'src/app/services/ebay.service';

@Component({
  selector: 'app-ebay-tests',
  templateUrl: './ebay-tests.component.html',
  styleUrls: ['./ebay-tests.component.scss']
})
export class EbayTestsComponent implements OnInit {

  constructor(private ebayService: EbayService) { }

  search = [];

  ngOnInit(): void {

  }

  test() {
    this.ebayService.getItem("374590237598").subscribe((r: any)=> {
        console.log(r.response);
    });
  }

  itemSpecifics() {
    this.ebayService.itemSpecifics(177).subscribe((r: any)=> {
      console.log(r);
    });
  }

  getConditionIDsForCategory() {
    this.ebayService.getConditionIDsForCategory(177).subscribe((r: any)=> {
      console.log(r);
    });
  }



}